import * as React from "react";
import { IParagraphPageIntroProps } from "./ParagraphPageIntroProps";
import { Container } from "./ParagraphPageIntroHelpers";
import { graphql, Slice } from "gatsby";
import { PageIntroSliceProvider } from "../../../context/SliceContexts/PageIntroContext";

const ParagraphPageIntro: React.FC<IParagraphPageIntroProps> = (props) => {
  return (
    <Container>
      <PageIntroSliceProvider
        value={{
          isbelowSearchParagraphs: props?.isbelowSearchParagraphs,
          ...props.node,
        }}
      >
        <Slice alias="page-intro" />
      </PageIntroSliceProvider>
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphPageIntro on paragraph__page_intro {
    id
    field_title
    field_description
    parent_type
    field_link {
      url
      title
    }
    relationships {
      field_amenities {
        name
        machine_name
      }
      field_sites {
        machine_name
      }
    }
  }
`;
export default ParagraphPageIntro;
